import React from 'react'
import {Box, Container, makeStyles, Typography} from '@material-ui/core'
import {grey} from '@material-ui/core/colors'
import useSWR from 'swr'
import {fetcher, url} from '../utils'

const textColor = grey[700]
const bgColor = grey[300]

function useBalance(id) {
  const {data, error} = useSWR(url(`/balance/${id}`), fetcher, {refreshInterval: 60000})
  return {
    balance: data,
    isLoading: !error && typeof data !== 'number',
    isError: error,
  }
}

function Footer() {
  const {balance: bglBalance, isLoading: bglLoading} = useBalance('bgl')
  const {balance: ethBalance, isLoading: ethLoading} = useBalance('eth')
  const {balance: bnbBalance, isLoading: bnbLoading} = useBalance('bnb')
  const {balance: opBalance, isLoading: opLoading} = useBalance('op')
  const {balance: arbBalance, isLoading: arbLoading} = useBalance('arb')
  const classes = useStyles()
  const balanceClass = isLoading => isLoading ? classes.pulsing : undefined

  return (
    <Box p={2} color={textColor} bgcolor={bgColor}>
      <Container maxWidth="sm">
        <Box display="flex" justifyContent="space-between">
          <Box>
            <Typography variant="subtitle1"><b>Balances:</b></Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1">
              BGL: <span className={balanceClass(bglLoading)}>{bglLoading ? 'Loading...' : bglBalance}</span>
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1">
              WBGL (Eth): <span className={balanceClass(ethLoading)}>{ethLoading ? 'Loading...' : ethBalance}</span>
            </Typography>
            <Typography variant="subtitle1">
              WBGL (OP): <span className={balanceClass(opLoading)}>{opLoading ? 'Loading...' : opBalance}</span>
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1">
              WBGL (BNB): <span className={balanceClass(bnbLoading)}>{bnbLoading ? 'Loading...' : bnbBalance}</span>
            </Typography>
            <Typography variant="subtitle1">
              WBGL (Arb): <span className={balanceClass(arbLoading)}>{arbLoading ? 'Loading...' : arbBalance}</span>
            </Typography>
          </Box>
        </Box>
      </Container>
      <Container maxWidth="sm">
        <Box display="flex" justifyContent="space-between">
          <Box>
            <Typography variant="subtitle1">
              Support: <a href="mailto:it@bitgesell.ca">it@bitgesell.ca</a> (attach tx id that you have sent)<br/>
              OTC deals BGL Discord: visit via <a href="https://discord.com/channels/745922397349347418/826719704709333033">#bgl-otc</a>
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

const useStyles = makeStyles(theme => ({
  none: {},
  pulsing: {
    opacity: 0.3,
    animation: '$pulse 0.7s alternate infinite',
  },
  '@keyframes pulse': {
    '0%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0.3,
    },
  },
}))

export default Footer
